/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData
     */
    AccountId: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData
     */
    AccountType: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData
     */
    GameSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData
     */
    AuthToken: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData {
    if (!('AccountId' in value) || value['AccountId'] === undefined) return false;
    if (!('AccountType' in value) || value['AccountType'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('AuthToken' in value) || value['AuthToken'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData {
    if (json == null) {
        return json;
    }
    return {
        
        'AccountId': json['AccountId'],
        'AccountType': json['AccountType'],
        'GameSystemName': json['GameSystemName'],
        'AuthToken': json['AuthToken'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AccountId': value['AccountId'],
        'AccountType': value['AccountType'],
        'GameSystemName': value['GameSystemName'],
        'AuthToken': value['AuthToken'],
    };
}

